module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-bar"
  }, [_c('router-link', {
    staticClass: "btn-back",
    attrs: {
      "tag": "div",
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "arrow-back",
    attrs: {
      "src": require("../assets/arrow-back.png")
    }
  })]), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74ed018d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/NavBar.vue
// module id = 46
// module chunks = 0